import React from 'react';
import { connect } from 'react-redux';

class RegisterError extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: "An error occurred while trying to register your account. Please try again."
        }
    }

    componentDidMount() {
        if (this.props.createAccount.error !== "" && this.props.createAccount.error.data
            && this.props.createAccount.error.data.message.includes('Duplicate')) {
            this.setState({
                errorMessage: `Account already registered with ${this.props.createAccount.email}. Please try again using a different email.`
            })
        }
    }

    render() {
        return (
            <div className="homeContainer">
                <div className="homeWelcomeContent">
                    <h1>
                        Registration Error
                    </h1>
                    <p>{this.state.errorMessage} If the problem persists please contact your system administrator.</p>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        createAccount: state.createAccount
    }
}

export default connect(mapStateToProps, null)(RegisterError);
